import React from 'react';
import { ImageContext } from '../../context/imageContext/imageContext';
export const ImageBase = (props) => {
    const { Image } = React.useContext(ImageContext);
    return Image ? React.createElement(Image, Object.assign({}, props)) : React.createElement("img", Object.assign({}, props));
};
export default ImageBase;
